import { setDomainAuthErrorHandler } from '@shared/api/api-factory'
import { IMMIGRATION_ROUTES } from './constants/routes'

export function initImmigrationDomain() {
  setDomainAuthErrorHandler('immigration', () => {
    if (typeof window !== 'undefined') {
      const currentPath = window.location.pathname
      if (!currentPath.startsWith(IMMIGRATION_ROUTES.LOGIN)) {
        window.location.href = `${IMMIGRATION_ROUTES.LOGIN}?requireAuth=true`
      }
    }
  })
}
